import { Observable, map } from "rxjs";
import { ParkerFunctionExecutor } from "./parker-function-executor.class";
import { ParkerClient, ParkerDTO, ParkingSubscriptionClient, UpdateParkerSubscriptionAssignmentDTO } from "src/app/base/models/models.swagger.generated";
import { SubscriptionAssignmentFormGroup } from "../../edit-parker-form/edit-parker-edit-subscription-list-form/edit-parker-edit-subscription-list-form.type";
import { DateTime } from "luxon";
import { UpdateParkerUtil } from "./update-parker.util";

export class AddSubscriptionExecutor extends ParkerFunctionExecutor {
  private now: DateTime;
  private validFrom: DateTime;
  private validTo: DateTime;

  constructor(numTotalRecordsToWorkOn: number, private subscriptionAssignmentForm: SubscriptionAssignmentFormGroup, private parkingSubscriptionClient: ParkingSubscriptionClient, private parkerClient: ParkerClient) {
    super(numTotalRecordsToWorkOn);
  }

  protected prepare(): Observable<void> {
    return this.parkingSubscriptionClient.getParkingSubscription(this.subscriptionAssignmentForm.controls.subscriptionId.value).pipe(map(sub => {
      this.now = DateTime.now();
      this.validFrom = this.subscriptionAssignmentForm.controls.validFrom.value ? DateTime.fromJSDate(this.subscriptionAssignmentForm.controls.validFrom.value) : this.now;
      this.validTo = this.subscriptionAssignmentForm.controls.validTo.value ? DateTime.fromJSDate(this.subscriptionAssignmentForm.controls.validTo.value) : null;
      if (this.validTo && this.validTo < this.validFrom) {
        this.validTo = this.validFrom;
      }
    }));
  }

  protected executeFunctionOnParker(parker: ParkerDTO): Observable<number> {
      let subscriptionAssignment = new UpdateParkerSubscriptionAssignmentDTO({
        active: this.subscriptionAssignmentForm.value.active,
        validFrom: this.validFrom,
        validTo: this.validTo,
        subscriptionId: this.subscriptionAssignmentForm.controls.subscriptionId.value,
        id: 0,
        isFavorite: false
      });
      const updateData = UpdateParkerUtil.createUpdateParkerDTO(parker);
      UpdateParkerUtil.addOrMergeSubscriptionAssignment(updateData, subscriptionAssignment, this.now);
      return this.parkerClient.updateParker(updateData).pipe(map(parker => parker.id));
  }

  protected preFilterParkersAndUpdateExecutionStatus(parkers: ParkerDTO[]): ParkerDTO[] {
    return parkers; // nothing to filter
  }
}
